import React, { useState } from "react";
import { Row, Col, Card, Timeline, Carousel, Statistic } from "antd";
import { motion } from "framer-motion";
import cardData from "./DescriptionsCards";
import welcome from "../assets/images/welcome.jpeg";
import survey from "../assets/images/survey final.png";
import Grievance from "../assets/images/grvnce final.png";
import message from "../assets/images/message.png";
import appointment from "../assets/images/ap final.png";
import {
  MessageOutlined,
  BarChartOutlined,
  CalendarOutlined,
  TeamOutlined,
  CheckCircleOutlined,
  LineChartOutlined,
  ScheduleOutlined,
  IdcardOutlined,
  CarOutlined,
} from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
const carouselData = [
  {
    img: `${welcome}`,
    text: "Explore the latest innovations in technology and digital transformation.",
  },
  {
    img: `${survey}`, 
    text: "Communicate directly with voters on important occasions.",
  },
  {
    img: `${Grievance}`,
    text: "Listen to and resolve the complaints.",
  },
  {
    img: `${message}`,
    text: "Schedule and organize appointments efficiently.",
  },
  {
    img: `${appointment}`,
    text: "Schedule and organize appointments efficiently.",
  },
];
const features = [
  {
    title: "Event Planner",
    text: "Organize events and plan your day effectively.",
    icon: <CalendarOutlined />,
    bg: "#ff4b2b",
  },
  {
    title: "Grievance Management",
    text: "Listen to and resolve voter complaints.",
    icon: <MessageOutlined />,
    bg: "#ff9900",
  },
  {
    title: "Travel Plan",
    text: "Plan and coordinate your travel schedules.",
    icon: <CarOutlined />,
    bg: "#4caf50",
  },
  {
    title: "Messaging System",
    text: "Communicate directly with voters on important occasions.",
    icon: <TeamOutlined />,
    bg: "#0088cc",
  },
  {
    title: "Transport",
    text: "Manage transportation logistics effectively.",
    icon: <IdcardOutlined />,
    bg: "#673ab7",
  },
  {
    title: "Appointment",
    text: "Schedule and organize appointments efficiently.",
    icon: <ScheduleOutlined />,
    bg: "#ff5722",
  },
];

const Home = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  const isMobile = useMediaQuery({ maxWidth: 768 }); // Phones
  const isTablet = useMediaQuery({ minWidth: 769, maxWidth: 1024 }); // iPads/Tablets
  const isDesktop = useMediaQuery({ minWidth: 1025 }); // Large screens

  const handleCardClick = (card) => {
    setSelectedCard(card);
    setSelectedCard(selectedCard?.title === card.title ? null : card);
  };
  const containerStyle = {
    textAlign: "center",
    padding: "40px 10px",
    background: "#f8f9fa",
    width: "100%",
    overflow: "hidden",
  };
  const cardStyle = {
    position: "relative",
    width: "240px",
    height: "300px",
    margin: "0 auto",
    gap: "20px",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    transition: "transform 0.4s ease, box-shadow 0.4s ease",
    cursor: "pointer",
  };
  const carouselStyle = {
    width: "100%",
    //  maxWidth: "1500px",
    //  height: "600px",
    maxWidth: isDesktop ? "1500px" : "100%",
    height: isMobile ? "250px" : isTablet ? "400px" : "650px", // Adjust height dynamically
    margin: "auto",
    background: "#fff",
    borderRadius: "10px",
    overflow: "hidden" ? "hidden" : "auto",
  };

  const overlayStyle = {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(to bottom, rgba(0, 123, 255, 0.8), rgba(0, 123, 255, 0))",
    transition: "opacity 0.4s ease, transform 0.4s ease",
    opacity: "0",
    transform: "translateY(-100%)",
  };

  const cardHoverStyle = {
    transform: "scale(1.05)",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3)",
  };

  return (
    <div style={containerStyle}>
      <motion.h1
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 2, ease: "easeOut" }}
        style={{
          fontSize: "2.6rem",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "-20px",
          background:
            "linear-gradient(to right,rgb(253, 135, 0),rgb(213, 199, 202),rgb(9, 69, 15))",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          letterSpacing: "1px",
        }}
      >
        Effortless Planning, Maximum Impact
      </motion.h1>
      <Carousel autoplay effect="fade" style={carouselStyle}>
        {carouselData.map((slide, index) => (
          <div
            key={index}
            style={{ position: "relative", width: "100%", height: "100px" }}
          >
            <img
              src={slide.img}
              alt="Slide"
              style={{
                width: "100%", 
                maxWidth: isDesktop ? "1500px" : "100%", 
                height: isMobile ? "250px" : isTablet ? "400px" : "650px",
                margin: "0",
                objectFit: "fill",
                borderRadius: "10px",
                transition: "0.4s ease-in-out",
                // padding : "10px 10px"
              }}
            />
            <div
              className="carousel-overlay"
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: "0",
                transition: "opacity 0.4s ease-in-out",
              }}
            >
              <p
                style={{
                  color: "white",
                  fontSize: "20px",
                  fontWeight: "bold",
                  textAlign: "center",
                  width: "80%",
                  opacity: "0",
                  transform: "translateY(20px)",
                  transition:
                    "opacity 0.4s ease-in-out, transform 0.4s ease-in-out",
                }}
              >
                {slide.text}
              </p>
            </div>
          </div>
        ))}
      </Carousel>

      {/* Hover Effect for Text */}
      <style>
        {`
          .carousel-overlay:hover {
            opacity: 1 !important;
          }
          .carousel-overlay:hover p {
            opacity: 1 !important;
            transform: translateY(0) !important;
          }
        `}
      </style>
      <div
        style={{ padding: "40px", background: "#f4f8fc", textAlign: "center" }}
      >
        {/* Who We Are */}
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5 }}
          style={{ fontSize: "32px", fontWeight: "bold", color: "#0e0a48" }}
        >
          Your Daily Operations, Managed Seamlessly
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 2, delay: 1 }}
          style={{
            fontSize: "18px",
            color: "#24245c",
            maxWidth: "800px",
            margin: "auto",
          }}
        >
          Manage your daily schedule, travel plans, and team assignments
          effortlessly.
        </motion.p>

        {/* What We Offer */}
        <h2
          style={{
            marginTop: "50px",
            fontSize: "28px",
            fontWeight: "bold",
            color: "#555580",
          }}
        >
          What We Offer
        </h2>
        <Row gutter={[16, 16]} justify="center" style={{ marginTop: "20px" }}>
          {features.map((feature, index) => (
            <Col key={index} xs={24} sm={12} md={8}>
              <motion.div
                whileHover={{ scale: 1.05 }}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: index * 0.1 }}
              >
                <Card
                  hoverable
                  style={{
                    borderRadius: "10px",
                    textAlign: "center",
                    padding: "20px",
                    background: "#fff",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <div style={{ fontSize: "40px", color: feature.bg }}>
                    {feature.icon}
                  </div>
                  <h3
                    style={{
                      marginTop: "10px",
                      fontSize: "18px",
                      fontWeight: "bold",
                    }}
                  >
                    {feature.title}
                  </h3>
                  <p style={{ fontSize: "14px", color: "#666" }}>
                    {feature.text}
                  </p>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>

        {/* Our Impact */}
        {/* <h2
          style={{
            marginTop: "50px",
            fontSize: "28px",
            fontWeight: "bold",
            color: "#333",
          }}
        >
          Our Impact
        </h2>
        <Row gutter={[16, 16]} justify="center" style={{ marginTop: "20px" }}>
          {[
            "Grievances Resolved",
            "Voters Engaged",
            "Surveys Conducted",
            "Constituencies Analyzed",
          ].map((title, index) => (
            <Col key={index} xs={24} sm={12} md={6}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Card style={{ textAlign: "center", borderRadius: "10px" }}>
                  <Statistic
                    title={title}
                    value={Math.floor(Math.random() * 10000) + 1000}
                  />
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row> */}
      </div>

      {/* 5 Animated Cards */}
      <div style={{ ...containerStyle, background: "#fff" }}>
        <h2
          style={{
            marginBottom: "30px",
            background:
              "linear-gradient(to right,rgb(227, 213, 216),rgb(190, 132, 16))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Featured Topics
        </h2>
        <Row gutter={[16, 16]} justify="space-evenly">
          {cardData.map((card, index) => (
            <Col key={index} xs={24} sm={12} md={8} lg={4}>
              <div
                style={{
                  ...cardStyle,
                  boxShadow:
                    selectedCard && selectedCard.title === card.title
                      ? "0px 5px 15px rgba(20, 116, 200, 0.44)"
                      : "none",
                  transform:
                    selectedCard && selectedCard.title === card.title
                      ? "scale(1.07)"
                      : "scale(1)",
                  transition: "all 0.3s ease-in-out",
                }}
                onClick={() => handleCardClick(card)}
                onMouseEnter={(e) => {
                  Object.assign(e.currentTarget.style, cardHoverStyle);
                  e.currentTarget.querySelector(".overlay").style.opacity = "1";
                  e.currentTarget.querySelector(".overlay").style.transform =
                    "translateY(0)";
                }}
                onMouseLeave={(e) => {
                  Object.assign(e.currentTarget.style, cardStyle);
                  e.currentTarget.querySelector(".overlay").style.opacity = "0";
                  e.currentTarget.querySelector(".overlay").style.transform =
                    "translateY(-100%)";
                }}
              >
                <img
                  src={card.img}
                  alt={card.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                />
                <div className="overlay" style={overlayStyle}></div>
                <div
                  style={{
                    position: "absolute",
                    bottom: "0",
                    background: "rgba(0,0,0,0.6)",
                    color: "#fff",
                    width: "100%",
                    textAlign: "center",
                    padding: "10px",
                  }}
                >
                  {card.title}
                </div>
              </div>
              {/* Display Description under the card on small screens */}
              {selectedCard && selectedCard.title === card.title && (
                <div
                  style={{
                    marginTop: "10px",
                    padding: "10px",
                    borderRadius: "10px",
                    background: "rgba(255, 255, 255, 0.9)",
                    backdropFilter: "blur(5px)",
                    boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.1)",
                    color: "#333",
                    textAlign: "justify",
                    display: "none",
                  }}
                  className="mobile-description"
                >
                  <h3>{selectedCard.title}</h3>
                  <p style={{ fontSize: "14px", lineHeight: "1.5" }}>
                    {selectedCard.description}
                  </p>
                </div>
              )}
            </Col>
          ))}
        </Row>
        {/* Display Description below the card section on larger screens */}
        {selectedCard && (
          <div
            style={{
              marginTop: "20px",
              padding: "20px",
              borderRadius: "15px",
              background: "rgba(255, 255, 255, 0.9)",
              backdropFilter: "blur(10px)",
              boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.1)",
              color: "#333",
              transition: "opacity 0.5s ease-in-out",
              maxWidth: "800px",
              margin: "20px auto",
              textAlign: "justify",
            }}
            className="desktop-description"
          >
            <h3>{selectedCard.title}</h3>
            <p
              style={{
                fontSize: "16px",
                lineHeight: "1.6",
                textAlign: "justify",
                whiteSpace: "pre-line",
              }}
            >
              {selectedCard.description}
            </p>
          </div>
        )}
      </div>
      <style>
        {`
          @media (max-width: 768px) {
            .desktop-description {
              display: none;
            }
            .mobile-description {
              display: block !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Home;
